const tableCellEquip = {
  cellHaveChecklist: 'Sim',
  cellNotHaveChecklist: 'Não',
}

export default tableCellEquip;